import { render, staticRenderFns } from "./CrudReturnReason.vue?vue&type=template&id=5b59384e&scoped=true"
import script from "./CrudReturnReason.vue?vue&type=script&lang=js"
export * from "./CrudReturnReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59384e",
  null
  
)

export default component.exports